import { Typo } from 'component/Typo/Typo'
import { observer } from 'mobx-react-lite'
import css from './ComboCartSteps.module.scss'
import { clsx } from 'clsx'
import { comboCartStore } from 'page/catalog/store/ComboCartStore'
import { Space } from 'component/Space'
import { i18n } from 'i18n'
import { Button } from 'component/Button'
import { Icon } from 'icon/Icon'

interface ComboCartStepsProps {
  currentStep: 'top' | 'bottom'
  onStepChange: (step: 'top' | 'bottom') => void
}

export const ComboCartSteps = observer(
  ({ currentStep, onStepChange }: ComboCartStepsProps) => {
    return (
      <div className={css.steps}>
        <Space gap={12} className={css.stepContainer}>
          <Button
            text
            compact
            className={clsx(css.stepButton, {
              [css.active]: currentStep === 'top',
              [css.empty]: !comboCartStore.selectedTopItem,
            })}
            action={() => onStepChange('top')}
          >
            <div className={css.stepNumber}>
              {comboCartStore.selectedTopItem ? (
                <Icon name="check" size={16} />
              ) : (
                <Typo size={11}>1</Typo>
              )}
            </div>
            <div className={css.stepText}>
              <Typo size={14} dotted>
                {i18n('combo.SelectTop')}
              </Typo>
            </div>
          </Button>
          <div className={css.separator} />
          <Button
            text
            compact
            className={clsx(css.stepButton, {
              [css.active]: currentStep === 'bottom',
              [css.empty]: !comboCartStore.selectedBottomItem,
            })}
            action={() => onStepChange('bottom')}
          >
            <div className={css.stepNumber}>
              {comboCartStore.selectedBottomItem ? (
                <Icon name="check" size={16} />
              ) : (
                <Typo size={11}>2</Typo>
              )}
            </div>
            <div className={css.stepText}>
              <Typo size={14} dotted>
                {i18n('combo.SelectBottom')}
              </Typo>
            </div>
          </Button>
        </Space>
      </div>
    )
  }
)
